import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './common/reportWebVitals';
import App from './App';
import './index.css';
import { AuthProvider } from './common/AuthProvider';
import { SubscriptionContextProvider } from './common/SubscriptionsProvider.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <SubscriptionContextProvider>
  <AuthProvider>
        <App />
  </AuthProvider>
  </SubscriptionContextProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

